import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Endpoints } from 'src/app/shared/config/endpoints';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';


@Injectable({
     providedIn: 'root'
})
export class TwitterService {
     org_id;
     user_id;

     user_data: any = new BehaviorSubject<any>({});
     listener_settings: any = new BehaviorSubject<any>({});

     replied_tweet: any = new BehaviorSubject<string>('');
     tweet_to_reply: any = new BehaviorSubject<any>({});

     private server_uri: string;

     constructor(
          private http: HttpClient,
          private endpoints: Endpoints,
          private store: Store<AppState>,
     ) {
          this.store.select('userInfo').subscribe(info => {
               if (Object.keys(info).length) {
                    this.org_id = info.organization.id
                    this.user_id = info.user.id;
               }
          })
          this.server_uri = this.endpoints.twitterServiceUrl;
     }



     /** */
     fetch_user_data() {
          return this.http.get(`${this.server_uri}/users/${this.org_id}`);
     }

     fetch_stream_setting() {
          return this.http.get(`${this.server_uri}/streams/organisation/${this.org_id}`);
     }

     set_stream_setting(payload) {
          return this.http.post(`${this.server_uri}/streams/organisation/`, { ...payload, org_id: this.org_id });
     }


     /**
     * GET TOKEN REQUEST
     **/
     fetch_Token() {
          return this.http.get(`${this.server_uri}/users/token/request`);
     }

     connect_To_Twitter(payload) {
          return this.http.post(`${this.server_uri}/users/token/access`, { ...payload, org_id: this.org_id });
     }

     disconnect_from_twitter(id) {
          return this.http.delete(`${this.server_uri}/users/${id}`);
     }

     /**
      * 
      */
     send_reply(payload) {
          return this.http.post(`${this.server_uri}/streams/reply/tweet`, { ...payload });
     }
}